import {
  MODULES,
  MODULE_CONFIGURATION_MAP,
  STAFF_PERMISSIONS_CONFIGURATIONS,
  ACCESS_LEVELS,
} from "lib/staffPermissionUtils";
import { DESIGNATION_CONSTANTS_MAP } from "modules/Services";
import {
  PROJECT_GROUP_TYPE_COMMUNITY,
  PROJECT_GROUP_TYPE_PERSONAL,
  PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
  PROJECT_GROUP_TYPE_DP_CAS,
  PROJECT_GROUP_TYPE_DP_EE,
  PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
  PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
  PROJECT_GROUP_TYPE_DP_G4_PROJECT,
  PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT,
  PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
  PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING,
  PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT,
} from "Projects/Constants/stringConstants";

const DP_CORE_MODULES = [
  MODULES[PROJECT_GROUP_TYPE_DP_EE].id,
  MODULES[PROJECT_GROUP_TYPE_DP_TOK_ESSAY].id,
  MODULES[PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION].id,
  MODULES[PROJECT_GROUP_TYPE_DP_CAS].id,
  MODULES[PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT].id,
  MODULES[PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING].id,
  MODULES[PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT].id,
];

const MYP_PROJECT_MODULES = [
  MODULES[PROJECT_GROUP_TYPE_PERSONAL].id,
  MODULES[PROJECT_GROUP_TYPE_COMMUNITY].id,
  MODULES[PROJECT_GROUP_TYPE_SERVICE_AS_ACTON].id,
];

const MODULE_CONFIGURATION_ID_MAP = {
  [MODULES.ATTENDANCE.id]: 3175,
  [MODULES.ANNOUNCEMENTS.id]: 3356,
  [MODULES.EVALUATION_CYCLES.id]: 3390,
  [MODULES.STUDENT_PROFILE.id]: 4121,
  [MODULES.PROGRESS_REPORTS.id]: 4120,
  [MODULES.CLASS_SETTINGS.id]: 4122,
  [MODULES.FAMILY_COMMUNICATION.id]: 3391,
  [MODULES[PROJECT_GROUP_TYPE_PERSONAL].id]: 3394,
  [MODULES[PROJECT_GROUP_TYPE_COMMUNITY].id]: 3395,
  [MODULES[PROJECT_GROUP_TYPE_SERVICE_AS_ACTON].id]: 3396,
  [MODULES[PROJECT_GROUP_TYPE_DP_EE].id]: 3397,
  [MODULES[PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT].id]: "23922281688339385",
  [MODULES[PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING].id]: "23923511131116474",
  [MODULES[PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT].id]: "285605054684077024",
  [MODULES[PROJECT_GROUP_TYPE_DP_TOK_ESSAY].id]: 3398,
  [MODULES[PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION].id]: 3399,
  [MODULES[PROJECT_GROUP_TYPE_DP_CAS].id]: 3400,
  [MODULES.STAFF_PERMISSIONS.id]: 4509,
  [MODULES.SCHOOL_CALENDAR.id]: 4510,
  [MODULES.ACADEMIC_SETUP.id]: 3392,
  [MODULES.EDUCATOR_CENTER.id]: 4512,
  [MODULES.CURRICULUM_SETTINGS.id]: 4513,
  [MODULES.PLANNING_INSIGHTS.id]: 4514,
  [MODULES.CLASS_SUMMARY.id]: 4517,
  [MODULES.IBIS_REGISTRATION.id]: 4519,
  [MODULES.IB_ECOURSEWORK.id]: 4520,
  [MODULES.SCHOOL_SETUP.id]: 4521,
  [MODULES.UNIT_PLANNING.id]: 4522,
  [MODULES[PROJECT_GROUP_TYPE_DP_G4_PROJECT].id]: 4588,
  [MODULES[PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT].id]: 4746,
  [MODULES.QUESTION_LIBRARY.id]: 4726,
  [MODULES.GRADEBOOK.id]: "115066635793995389",
  [MODULES.BEHAVIOUR_MANAGEMENT.id]: "163060427465430968",
};

const FEED_MODE = {
  VIEW: "VIEW",
  EDIT: "EDIT",
};

const FEED_CUSTOM_COMPONENT = {
  TEXT_FIELD: "TEXT_FIELD",
  TEXT_EDIT_FIELD: "TEXT_EDIT_FIELD",
  PERMISSION_STATUS_VIEW: "PERMISSION_STATUS_VIEW",
  PERMISSION_STATUS_DROPDOWN: "PERMISSION_STATUS_DROPDOWN",
  MODULE_ACCESS_VIEW: "MODULE_ACCESS_VIEW",
  MODULE_ACCESS_DROPDOWN: "MODULE_ACCESS_DROPDOWN",
  CUSTOM_NAME_AVATAR: "CUSTOM_NAME_AVATAR",
};

const PERMISSION_STATUS_TYPE = {
  ALL: "ALL",
  TEACHER: "TEACHER",
  TEACHER_CUSTOM: "TEACHER_CUSTOM",
  ADMIN_CUSTOM: "ADMIN_CUSTOM",
  ADMIN: "ADMIN",
};

const PERMISSION_STATUS_DROPDOWN_OPTIONS = [
  {
    key: PERMISSION_STATUS_TYPE.ADMIN,
    descriptionLocale: "configuration:staff_perm_access_admin_access_desc",
    ...ACCESS_LEVELS.ADMIN_ACCESS,
  },
  {
    key: PERMISSION_STATUS_TYPE.TEACHER,
    descriptionLocale: "configuration:staff_perm_access_teacher_access_desc",
    ...ACCESS_LEVELS.TEACHER_ACCESS,
  },
];

const PERMISSION_STATUS_VIEW_OPTIONS = [
  {
    key: PERMISSION_STATUS_TYPE.ADMIN_CUSTOM,
    descriptionLocale: "configuration:staff_perm_access_admin_access_desc",
    ...ACCESS_LEVELS.ADMIN_ACCESS,
  },
  {
    key: PERMISSION_STATUS_TYPE.TEACHER_CUSTOM,
    descriptionLocale: "configuration:staff_perm_access_teacher_access_desc",
    ...ACCESS_LEVELS.TEACHER_ACCESS,
  },
  ...PERMISSION_STATUS_DROPDOWN_OPTIONS,
];

const FEED_TYPE = {
  ADMINISTRATORS: "ADMINISTRATORS",
  TEACHERS: "TEACHERS",
};

const FEED_DESIGNATION_ID_MAP = {
  [FEED_TYPE.ADMINISTRATORS]: [DESIGNATION_CONSTANTS_MAP.SCHOOL_ADMIN.id],
  [FEED_TYPE.TEACHERS]: [DESIGNATION_CONSTANTS_MAP.TEACHER.id],
};

const FEED_CHILD_HEADER_SUBTEXT = {
  [FEED_TYPE.ADMINISTRATORS]: "common:staff_permissions_admin_header_subtext",
  [FEED_TYPE.TEACHERS]:
    "common:staff_permissions_curriculum_teachers_header_subtext",
};

export {
  MODULES,
  MODULE_CONFIGURATION_MAP,
  DP_CORE_MODULES,
  MYP_PROJECT_MODULES,
  MODULE_CONFIGURATION_ID_MAP,
  FEED_MODE,
  FEED_CUSTOM_COMPONENT,
  PERMISSION_STATUS_TYPE,
  PERMISSION_STATUS_DROPDOWN_OPTIONS,
  PERMISSION_STATUS_VIEW_OPTIONS,
  STAFF_PERMISSIONS_CONFIGURATIONS,
  FEED_TYPE,
  FEED_DESIGNATION_ID_MAP,
  FEED_CHILD_HEADER_SUBTEXT,
};
